export const createErrorMessageSelector = actions => (state) => {
  const errors = actions.map(action => state.error[action]).filter(error => error);

  if (errors && errors[0]) {
    return errors[0];
  }
  return '';
 };